import React from "react";
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { COLORS } from "../../../assets/colors";
import Typography from '@mui/material/Typography';
import { CategoriesProductsUI } from "../CategoriesProducts/CategoriesProductsUI";
import { useState, useEffect } from 'react';
import './Subcategories.css';
import { useNavigate } from 'react-router-dom';
import { ROUTES_PATH } from "../../../utils/Consts"

const Item = styled(Paper)(({ theme, selected }) => ({
    background: selected 
        ? `linear-gradient(135deg, ${COLORS.primary} 0%, rgba(30, 58, 95, 0.95) 100%)`
        : '#ffffff',
    borderRadius: '16px',
    border: selected ? '3px solid #d7b547' : '3px solid transparent',
    padding: '16px',
    textAlign: 'center',
    cursor: 'pointer',
    position: 'relative',
    overflow: 'hidden',
    transition: 'all 0.3s ease',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: selected ? '0px 6px 20px rgba(0, 0, 0, 0.4)' : '0px 2px 8px rgba(0, 0, 0, 0.08)',
    '&:hover': {
        transform: 'translateY(-8px)',
        boxShadow: '0px 12px 32px rgba(215, 181, 71, 0.4)',
        border: '3px solid #e6c663',
    },
}));

const handleMouseDown = (event) => {
    event.preventDefault();
    const lista = document.getElementById("miLista");
    const initialX = event.clientX;
    const initialScrollLeft = lista.scrollLeft;

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);

    function handleMouseMove(event) {
        const distanceX = event.clientX - initialX;
        lista.scrollLeft = initialScrollLeft - distanceX;
    }

    function handleMouseUp() {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
    }
}

function SubCategoriesUI({
    data,
    categoryId,
    subCategoryId,
    subCategoryName
}) {
    const [propSubCategoryId, setSubCategoryId] = useState('');
    const [propSubCategoryName, setSubCategoryName] = useState('');
    const navigate = useNavigate();
    const onClickItem = (id) => {
        if (subCategoryId !== id) {
            const name = data.find(subCategory => subCategory.id === id).name;
            setSubCategoryId(id);
            setSubCategoryName(name);
            navigate(`${ROUTES_PATH.CATEGORIES}/${categoryId}?subCategoryId=${id}&subCategoryName=${encodeURIComponent(data.find(subCategory => subCategory.id === id).name)}`);
        }
    };

    useEffect(() => {
        if (subCategoryId !== null) {
            setSubCategoryId(subCategoryId);
            setSubCategoryName(subCategoryName);
        } else {
            setSubCategoryId(data[0].id);
            setSubCategoryName(data[0].name);
        }
    }, [data]);

    return (
        <div>
            <Box sx={{
                flexDirection: 'column'
            }}>
                <Box id="miLista" sx={{
                    display: 'flex',

                    maxWidth: '100vw',
                    overflowX: 'auto',
                    padding: { xs: '20px 20px', sm: '20px 20px', md: '20px 60px', lg: '20px 60px', xl: '20px 60px' }
                }}
                    onMouseDown={handleMouseDown}>
                    <Stack direction="row" spacing={2} >
                        {
                            data.map(subCategories => (
                                <Item 
                                    key={subCategories.id} 
                                    selected={subCategories.id === propSubCategoryId}
                                    sx={{
                                        width: "150px",
                                        height: "200px",
                                        minWidth: "150px"
                                    }}
                                    onClick={() => onClickItem(subCategories.id)}
                                >
                                    <Box sx={{
                                        width: '100%',
                                        height: '110px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginBottom: '10px'
                                    }}>
                                        <img 
                                            src={subCategories.image} 
                                            loading="lazy" 
                                            alt={subCategories.name}
                                            style={{ 
                                                width: '100%', 
                                                height: '100%',
                                                objectFit: 'contain'
                                            }} 
                                        />
                                    </Box>
                                    <Typography variant="title" component="h3"
                                        sx={{
                                            fontFamily: 'Quicksand',
                                            fontSize: '1rem',
                                            textAlign: 'center',
                                            fontWeight: 'bold',
                                            color: subCategories.id === propSubCategoryId ? COLORS.secondary : COLORS.secondary
                                        }}>
                                        {subCategories.name}
                                    </Typography>
                                </Item>
                            ))
                        }
                    </Stack >
                </Box>
            </Box>
            {(propSubCategoryId !== '') && (
                <CategoriesProductsUI
                    propSubCategoryId={propSubCategoryId}
                    propSubCategoryName={propSubCategoryName}
                />
            )}

        </div>

    )
}

export { SubCategoriesUI };